import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/moodbuster-logo.svg'
import _imports_1 from '../assets/hamburguer.svg'
import _imports_2 from '../assets/close_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-52992652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "row logo-row" }
const _hoisted_3 = { class: "header-desktop" }
const _hoisted_4 = { id: "header-desktop-top-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  alt: "Moodbuster logo",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { class: "header-wrapper" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  id: "header-therapist"
}
const _hoisted_9 = {
  key: 0,
  id: "navigationBar",
  class: "row"
}
const _hoisted_10 = {
  key: 1,
  class: "row menus-disabled"
}
const _hoisted_11 = { class: "header-mobile" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  alt: "Moodbuster logo",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainProgress = _resolveComponent("MainProgress")!
  const _component_HeaderMenu = _resolveComponent("HeaderMenu")!
  const _component_HeaderTherapist = _resolveComponent("HeaderTherapist")!
  const _component_NavigationBar = _resolveComponent("NavigationBar")!
  const _component_NavigationMobile = _resolveComponent("NavigationMobile")!
  const _component_ProgressModal = _resolveComponent("ProgressModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "main-progress",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openProgressModal()))
          }, [
            (_ctx.menus)
              ? (_openBlock(), _createBlock(_component_MainProgress, {
                  key: 0,
                  percentage: _ctx.currentPercentage,
                  mainColor: _ctx.mainProgressMainColor,
                  borderThickness: _ctx.mainProgressBorderThick,
                  width: _ctx.mainProgressWidth,
                  fontSize: _ctx.mainProgressFontSize
                }, null, 8, ["percentage", "mainColor", "borderThickness", "width", "fontSize"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.menus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_HeaderMenu)
                ]))
              : _createCommentVNode("", true),
            (_ctx.menus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_HeaderTherapist)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.menus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_NavigationBar)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.menus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          class: "main-progress",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openProgressModal()))
        }, [
          (_ctx.menus)
            ? (_openBlock(), _createBlock(_component_MainProgress, {
                key: 0,
                percentage: _ctx.currentPercentage,
                mainColor: _ctx.mainProgressMainColor,
                borderThickness: _ctx.mainProgressBorderThick,
                width: _ctx.mainProgressWidth,
                fontSize: _ctx.mainProgressFontSize
              }, null, 8, ["percentage", "mainColor", "borderThickness", "width", "fontSize"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.menus && !_ctx.expanded)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "hamburguer",
              src: _imports_1,
              alt: "hamburguer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandHeadermenu()))
            }))
          : _createCommentVNode("", true),
        (_ctx.menus && _ctx.expanded)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "close-icon",
              src: _imports_2,
              alt: "close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeMenu()))
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.menus)
        ? (_openBlock(), _createBlock(_component_NavigationMobile, {
            key: 0,
            menu: _ctx.menus,
            expanded: _ctx.expanded
          }, null, 8, ["menu", "expanded"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showProgressModal)
      ? (_openBlock(), _createBlock(_component_ProgressModal, {
          key: 0,
          showProgressModal: _ctx.showProgressModal,
          onClicked: _ctx.onChildClick
        }, null, 8, ["showProgressModal", "onClicked"]))
      : _createCommentVNode("", true)
  ]))
}